<template>
  <!-- <div class="foot_bar">
        <span>Copyright © 2015 - {{currentYear}}</span>
        <router-link to="/" class="index_link">zqkh.com.cn</router-link>
        <span>
            All Rights Reserved. 湖南省新华书店 版权所有
            <span class="devide"></span>
            <span class="version" v-if="appVersion">版本: {{appVersion}}</span>
            <span class="devide"></span>
            <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=43010502001514" target="_blank">
              公安备案号：<img class="police_icon" src="@/assets/icons/icon_police.png" />湘公网安备 43010502001514号
            </a>
            <span class="devide"></span>
            <a href="https://beian.miit.gov.cn/" target="_blank">ICP备案号：湘ICP备11013470号-14</a>
        </span>
    </div> -->
  <div class="foot_bar home_foot_bar">
    <div>
      <span>Copyright © 2015 - {{ currentYear }}</span>
      <router-link to="/" class="index_link">zqkh.com.cn</router-link>
      <span>All Rights Reserved. 湖南省新华书店 版权所有</span>
      <span class="devide"></span>
      <!-- <span class="version" v-if="appVersion">版本: {{ appVersion }}</span> -->
    </div>
    <div>
      <a
        href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=43010502001514"
        target="_blank"
        class="img-content hover"
      >
        <img
          class="police_icon"
          src="@/assets/icons/icon_police.png"
        />湘公网安备 43010502001514号
      </a>
      <span class="devide"></span>
      <a class="hover" href="https://beian.miit.gov.cn/" target="_blank"
        >湘ICP备11013470号-14</a
      >
    </div>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import { version } from "../../package.json";

@Component({})
export default class FootBar extends Vue {
  get currentYear() {
    const date = new Date();
    return date.getFullYear();
  }
  appVersion = version;
}
</script>
<style lang="less" scoped>
.foot_bar {
  border-top: 1px #e7e8eb solid;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 5rem;
  font-size: 1.2rem;
  span,
  a {
    color: #666666;
  }
  a {
    text-decoration: none;
    white-space: nowrap;
    margin: 0 0.5em;
  }
}

.home_foot_bar {
  height: 8rem;
  display: flex;
  flex-direction: column;
  div {
    margin: 0.5rem 0;
    display: flex;
  }
}

.img-content {
  display: flex;
  align-items: center;
}
.ico {
  font-family: SimSun, serif;
}
.devide {
  display: inline-block;
  content: "";
  width: 1em;
  height: 1px;
}
.police_icon {
  margin-right: 2px;
  height: 1.2rem;
  vertical-align: middle;
}
.hover:hover {
  text-decoration: underline;
}
</style>